const RightArrow = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6806_2990)">
        <rect
          width="48"
          height="48"
          rx="24"
          transform="matrix(-1 0 0 1 48 0)"
          fill="black"
          fill-opacity="0.2"
        />
        <path
          d="M20 12L32 24L20 36"
          stroke="white"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6806_2990">
          <rect
            width="48"
            height="48"
            rx="24"
            transform="matrix(-1 0 0 1 48 0)"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default RightArrow;
